<template>
    <delegations />
</template>

<script>
import delegations from '@/components/Delegation.vue';
	export default {
		name: 'Delegations',
        components: {delegations},
        data () {
            return {}
        },
	}
</script>